import api from 'api';

export const OPCO_SET_DATA = 'OPCO_SET_DATA';
export const OPCO_RESET_STATE = 'OPCO_RESET_STATE';
export const OPCO_ASYNC_START = 'OPCO_ASYNC_START';
export const OPCO_ASYNC_ERROR = 'OPCO_ASYNC_ERROR';

const opcoAsyncStart = () => ({
    type: OPCO_ASYNC_START,
});

const setOpcoData = opcos => ({
    type: OPCO_SET_DATA,
    payload: { opcos }
});

export const resetOpcoData = () => ({
    type: OPCO_RESET_STATE,
});

const opcoAsyncError = error => ({
    type: OPCO_ASYNC_ERROR,
    payload: { error },
});

/**
 * Fetch opcos from backend
 */
export function fetchOpcos() {
    return dispatch => {
        dispatch(opcoAsyncStart());
        return api.request(`opcos`, 'get')
            .then(data => {
                dispatch(setOpcoData(data));
                return data;
            })
            .catch(err => {
                dispatch(opcoAsyncError(err && err.message));
            });
    };
}
